import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import EnrollExistingListView from 'automation-ui-canvas/containers/review/EnrollExistingListView';
import { getEnrollmentList } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import EnrollExistingManualView from 'automation-ui-canvas/containers/review/EnrollExistingManualView';
import EnrollExistingScheduleView from 'automation-ui-canvas/containers/review/EnrollExistingScheduleView';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollExistingSection = ({
  flow,
  enrollExistingState,
  setEnrollExistingState
}) => {
  const triggerType = getExistingTriggerType(flow.toHybridFlowInterface());
  const enrollmentList = getEnrollmentList(flow);
  switch (triggerType) {
    case 'LIST':
      if (enrollmentList) {
        return /*#__PURE__*/_jsx(EnrollExistingListView, {
          enrollmentList: enrollmentList,
          objectTypeId: flow.objectTypeId,
          flowName: flow.getName() || '',
          enrollExistingState: enrollExistingState,
          setEnrollExistingState: setEnrollExistingState
        });
      }
      break;
    case 'SCHEDULE':
      return /*#__PURE__*/_jsx(EnrollExistingScheduleView, {
        enrollmentList: enrollmentList,
        flow: flow
      });
      break;
    default:
      return /*#__PURE__*/_jsx(EnrollExistingManualView, {
        flow: flow,
        enrollExistingState: enrollExistingState,
        setEnrollExistingState: setEnrollExistingState
      });
  }
  return null;
};
export default EnrollExistingSection;